import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';
import { AirbnbOfficialLinkStatus } from 'uplisting-frontend/models/airbnb-official-link';

export default class AirbnbOfficialLinkAdapter extends ApplicationV1Adapter {
  unlink(id: string): Promise<object> {
    const data = {
      data: { id, attributes: { status: AirbnbOfficialLinkStatus.inactive } },
    };

    return this.ajax(this.buildURL('airbnb-official-link', id), 'PATCH', {
      data,
    }) as Promise<object>;
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'airbnb-official-link': AirbnbOfficialLinkAdapter;
  }
}
